<div class="card-component-wrap" [ngClass]="{ opened: open | async }">
  <div *ngIf="mobileModal && modalTitle" class="d-not-phone-none phone-modal-header with-title">
    <button class="no-style back-btn" (click)="close()">
      <mat-icon [svgIcon]="'next'" class="square-icon arrow-icon"></mat-icon>
    </button>
    <div *ngIf="modalTitle" class="separator"></div>
    {{ modalTitle }}
  </div>

  <mat-card class="mb-0">
    <mat-card-content>
      <div *ngIf="mobileModal" class="d-not-phone-none phone-modal-header">
        <button class="no-style back-btn" (click)="close()">
          <mat-icon [svgIcon]="'prev'" class="square-icon arrow-icon"></mat-icon>
        </button>
      </div>

      <ng-content></ng-content>
    </mat-card-content>
  </mat-card>
</div>
